/**
 * API request data object used for both get and post
 */
export interface ApiRequestData {
    [key: string]: string | string[] | number | number[] | boolean | null | DocumentUpload;
}

export interface Amld5Answer {
    [key: string]: string;
}

export interface DocumentUpload {
    [side: string]: string | ArrayBuffer;
}

/**
 * API response errors
 */
export interface ApiResponseException {
    status: number;
    data: {
        errors: {
            [code: string]: ApiError;
        };
    };
    isAuthTokenExpired?: boolean;
    isCancelled?: boolean;
}

export interface ApiError {
    code: string;
    message: string;
    solution?: string;
}

/**
 * API response errors and codes
 */
export const ApiErrorCodes = {
    ER001: 'ER001',
    ER002: 'ER002',
    ER003: 'ER003',
    ER004: 'ER004',
    ER005: 'ER005',
    ER036: 'ER036',
    ER037: 'ER037',
    ER301: 'ER301',
    ER700: 'ER700',
    ER701: 'ER701',
    ER702: 'ER702',
    ER800: 'ER800',
    ER801: 'ER801',
    ER805: 'ER805',
    ER806: 'ER806',
    ER920: 'ER920',
    ER999: 'ER999'
};

/**
 * API refresh call response
 */
export interface RefreshTokensResponse {
    token: string;
    refreshToken: string;
}

/**
 * State of initialization for composables.
 */
export const enum InitializationStates {
    NOT_INITIALIZED,
    INITIALIZING,
    INITIALIZED
}

/**
 * State of communication for composables.
 */
export const enum ApiCommunicationStates {
    NOT_STARTED,
    COMMUNICATING,
    SUCCESSFUL,
    FAILED,
    CANCELLED
}
